import { FC } from "react";
import { Container, Row, Col } from "react-bootstrap";
import QRCode from "qrcode.react";
import { useParams } from "react-router-dom";

export const QrContent: FC = () => {
  let { guid } = useParams();
  console.log(guid);
  return (
    <Container className="my-auto" fluid="sm" style={{ maxWidth: 600 }}>
      <Row>
        <Col>
          <h5 className="text-light">
            Per associare questo archivio al tuo smartphone:
          </h5>
          <ul>
            <li className="text-light fs-5">
              se non l'hai già fatto, scarica <i>Danea Transfer</i> dall'App
              Store (iOS) o dal Play Store (Android);
            </li>
            <li className="text-light fs-5">
              avvia l'App e inquadra con la fotocamera il disegno sottostante
              (QR Code).
            </li>
          </ul>
        </Col>
      </Row>
      <Row className="p-2">
        <QRCode value={guid ?? ""} size={180} level="H" renderAs="svg" />
      </Row>
      <Row>
        <Col>
          <h5 className="text-light mt-2">
            Se hai già abbinato uno o più archivi, per attivare la fotocamera
            dall'App fai clic sull'Archivio e quindi
            <i> Aggiungi archivio</i>.
          </h5>
        </Col>
      </Row>
    </Container>
  );
};
